import React, { CSSProperties } from 'react';
import type { ClearIndicatorProps, GroupBase } from 'react-select';

import ICONS from '../../constants/icons';

const CustomClearIndicator = <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>,
>(
    props: ClearIndicatorProps<Option, IsMulti, Group>,
) => {
    const {
        children = <ICONS.trash />,
        getStyles,
        innerProps: { ref, ...restInnerProps },
    } = props;

    const style = {
        ...getStyles('clearIndicator', props),
        cursor: 'pointer',
    } as CSSProperties;

    return (
        <div {...restInnerProps} ref={ref} style={style}>
            {children}
        </div>
    );
};

export default CustomClearIndicator;
